import {useLogin} from "./dialogs/Login"
import PasswordList from "./components/PasswordList"
import Header from "./components/Header"
import PerfectScrollbar from "react-perfect-scrollbar"
import Search from "./components/Search"
import GoogleAds from "./components/GoogleAds"
import { useState, useEffect } from "react"

export default function App(){
    const [scroll,setScroll] = useState<boolean>(false)
    const {isLoggedIn} = useLogin()
    const onScroll = (e:any) => setScroll(e.scrollTop>0)

    if (isLoggedIn) {
        return <>
            <Header/>
            <Search className={scroll ? "scroll" : ""}/>
            <PerfectScrollbar onScrollY={onScroll}>
                <PasswordList/>
            </PerfectScrollbar>
        </>
    }
    return <></>
}
